import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './CannedJobs.css';

function CannedJobs({ onLogout }) {
  const navigate = useNavigate();
  const [cannedJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="home-container">
      <Sidebar onLogout={onLogout} />
      <div className="main-section">
        <div className="canned-jobs-container">
          <header className="canned-jobs-header">
            <button className="app-back-button" onClick={() => navigate('/inventory')}>
              Back
            </button>
            <h1>Canned Jobs</h1>
            <button className="btn-add">+ Create Package</button>
          </header>

          <div className="canned-jobs-content">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search canned jobs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {cannedJobs.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">P</div>
                <h2>No Canned Jobs Found</h2>
                <p>Create bundles by combining parts and labor services</p>
              </div>
            ) : (
              <div className="canned-jobs-table">
                <table>
                  <thead>
                    <tr>
                      <th>Job Name</th>
                      <th>Description</th>
                      <th>Parts Count</th>
                      <th>Labor Hours</th>
                      <th>Total Price</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cannedJobs.map((job, index) => (
                      <tr key={index}>
                        <td>{job.name}</td>
                        <td>{job.description}</td>
                        <td>{job.partsCount}</td>
                        <td>{job.laborHours}</td>
                        <td>${job.totalPrice}</td>
                        <td>
                          <button className="btn-edit">Edit</button>
                          <button className="btn-delete">Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CannedJobs;
